import React, { ReactElement } from 'react';
import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { ColorProperty } from 'csstype';

type Props = {
  children?:
    | string
    | ReactElement<any, string | ((props: any) => ReactElement<any, any>)>
    | undefined;
  color?: ColorProperty;
} & ButtonProps;

export default (props: Props) => {
  const { children, color, ...p } = props;

  const otherProps = {} as Props;
  if (color && !p.type) {
    otherProps.style = {
      ...p.style,
      color: p.ghost ? color : '#FFF',
      backgroundColor: p.ghost ? 'transparent' : color,
      borderColor: color,
    };
  }
  return (
    <Button size="small" {...p} {...otherProps}>
      {children}
    </Button>
  );
};
